import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import merge from 'lodash/merge';

import base from './base.theme';

const sywTheme = createMuiTheme(
  merge({}, base, {
    overrides: {
      MuiButton: {
        containedPrimary: {
          color: '#fff',
        },
      },
    },
    typography: {
      fontFamily: 'Montserrat, Arial',
    },
    palette: {
      primary: {
        main: 'rgb(73,204,104)', // #49cc68
      },
      secondary: {
        main: 'rgb(73,204,104)', // #49cc68
      },
      accent: {
        main: 'rgb(73,204,104)', // #49cc68
        secondary: '#E2E2E2',
      },
      accentLight: {
        main: 'rgba(73,204,104, 0.3)',
      },
      grey: {
        main: 'rgb(224,224,224)', // #E0E0E0
        withOpacity: 'rgba(224,224,224, .8)',
        secondary: '#fff',
        third: '#F9F9F9',
      },
      greyDark: {
        main: '#757575',
        secondary: '#545454',
      },
      border: {
        main: 'rgba(16,19,20,0.1)', // #101314 + opacity 0.12
      },
      dark: {
        main: '#000000',
        secondary: '#101314',
        withOpacity: 'rgba(0, 0, 0, 0.6)',
      },
      selection: {
        main: 'rgba(255,255,255,0.3)',
      },
    },
  })
);

export default responsiveFontSizes(sywTheme);
